import { components } from 'gridstrap/lib/gs-components';
import { GSForm } from './form';

import './form.scss';

components.register({
	selector: '.gs-Form',
	controller: GSForm
});
